/**
 * Size Guide Lightbox
 * Maneja la funcionalidad del lightbox para la guía de tallas
 */

class SizeGuideLightbox {
  constructor(blockId) {
    this.blockId = blockId;
    this.trigger = document.querySelector(`[data-size-guide-trigger="${blockId}"]`);
    this.lightbox = document.querySelector(`[data-size-guide-lightbox="${blockId}"]`);
    this.closeElements = document.querySelectorAll(`[data-size-guide-close="${blockId}"]`);
    this.imageWrapper = this.lightbox?.querySelector('.size-guide-lightbox__image-wrapper');

    if (this.trigger && this.lightbox) {
      this.init();
    }
  }

  init() {
    // Mover el lightbox al body para evitar problemas de z-index con contenedores padres
    if (this.lightbox.parentElement !== document.body) {
      document.body.appendChild(this.lightbox);
    }

    // Abrir lightbox
    this.trigger.addEventListener('click', (e) => this.open(e));

    // Cerrar lightbox con elementos específicos
    this.closeElements.forEach((element) => {
      element.addEventListener('click', (e) => {
        // Solo cerrar si el click es en el elemento de cierre, no en sus hijos
        if (e.target === element || element.classList.contains('size-guide-lightbox__close')) {
          this.close(e);
        }
      });
    });

    // Prevenir que el click en la imagen cierre el lightbox
    if (this.imageWrapper) {
      this.imageWrapper.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }

    // Cerrar con tecla ESC
    document.addEventListener('keydown', (e) => this.handleEscape(e));
  }

  open(e) {
    e.preventDefault();
    this.lightbox.style.display = 'block';
    setTimeout(() => {
      this.lightbox.classList.add('is-active');
    }, 10);
    document.body.style.overflow = 'hidden';
  }

  close(e) {
    if (e) e.preventDefault();
    this.lightbox.classList.remove('is-active');
    setTimeout(() => {
      this.lightbox.style.display = 'none';
    }, 300);
    document.body.style.overflow = '';
  }

  handleEscape(e) {
    if (e.key === 'Escape' && this.lightbox.classList.contains('is-active')) {
      this.close();
    }
  }
}

// Auto-inicializar todos los lightboxes de guía de tallas en la página
document.addEventListener('DOMContentLoaded', () => {
  const lightboxes = document.querySelectorAll('[data-size-guide-lightbox]');
  lightboxes.forEach((lightbox) => {
    const blockId = lightbox.getAttribute('data-size-guide-lightbox');
    new SizeGuideLightbox(blockId);
  });
});

